<div class="flip-individual-graph-header">
  <app-header-bar
    (routerLinkClick)="routerLinkClicked()"
    *ngIf="_dob != undefined || _dob != null"
    [age]="_age"
    [dob]="_dob"
    [showButton]="false"
    [showClientDetails]="false"
    [title]="_clientName"
  />
</div>
<!-- Client Information -->
<div class="dashboard-side-card-container">
  <app-client-information
    [attributes]="_clientInformationAttributes"
    [isVertialOrientation]="true"
    [title]="_clientInformationTitle"
    [urlDisplayText]="_clientInformationDisplayText"
    [url]="_clientInformationUrl"
    id="client-information"
    subtitle=""
  />
</div>
<!-- Sub-Menu -->
<app-sub-menu
  (navigateBackClick)="routerLinkClicked()"
  [clientId]="_clientId"
  [flipHasAccess]="_hasAccess.flipHasAccess"
  [reddiHasAccess]="_hasAccess.reddiHasAccess"
  [showBackButton]="true"
  [slatHasAccess]="_hasAccess.slatHasAccess"
  [totalReviews]="_totalReviews"
/>
<div class="flip-individual-graph-main-primary-card-container">
  <app-primary-card
    class="main-primary-card"
    headerSize="small"
    paddingSize="none"
    size="full"
  >
    <app-flip-dashboard-graph [clientId]="_clientId"></app-flip-dashboard-graph>
  </app-primary-card>
</div>
